export const getCountiesForSeason = seasonId =>
  fetch(`${process.env.REACT_APP_API_URL}/CountryCs/getForSeason/${seasonId}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.json());



// WEBPACK FOOTER //
// ./src/api/countyAPI.js